import type { TeamSummaryDto } from "@/lib/tanstack-query/dtos/team.dto";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const STORAGE_KEY = "TEAM_STORE";

type TeamStore = {
  currentTeam: TeamSummaryDto | null;
  setCurrentTeam: (team: TeamSummaryDto | null) => void;
};

export const useTeamStore = create<TeamStore>()(
  persist(
    (set) => ({
      currentTeam: null,
      setCurrentTeam: (team) => set({ currentTeam: team }),
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
